import { connect } from 'react-redux';
import withRouter from 'shared/helper/with-router';
import { getDigitalEdit, getPreviousUrl, getAccessType } from '../reducer';
import { archiveDigitalEdit, getDownloadUrl, searchDigitalEdits, updateDisplayedDigitalEdits } from '../actions';
import DigitalEditDetails from './DigitalEditDetails';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var digitalEdit = _ref.digitalEdit;
  var match = _ref2.match,
    location = _ref2.location;
  return {
    accessType: getAccessType({
      digitalEdit: digitalEdit
    }),
    digitalEdit: getDigitalEdit({
      match: match,
      digitalEdit: digitalEdit
    }),
    digitalEditIdentity: match.params.identity,
    previousUrl: getPreviousUrl({
      location: location
    }),
    status: digitalEdit.status
  };
};
var mapDispatchToProps = {
  archiveDigitalEdit: archiveDigitalEdit,
  getDownloadUrl: getDownloadUrl,
  searchDigitalEdits: searchDigitalEdits,
  updateDisplayedDigitalEdits: updateDisplayedDigitalEdits
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DigitalEditDetails));